import './Messagerie.css';

/**
 * La pagination d'un dossier de la messagerie (dix messages par page).
 *
 * Les numéros à montrer : tous s'il y en a peu, sinon la première, la
 * dernière, et les voisines de la page courante, séparées par « … ».
 */
function numeros(page, pages) {
  if (pages <= 7) return [...Array(pages).keys()];

  const garder = new Set([0, pages - 1, page - 1, page, page + 1]);
  const liste = [...garder].filter((n) => n >= 0 && n < pages).sort((a, b) => a - b);

  return liste.flatMap((n, i) => (i > 0 && n - liste[i - 1] > 1 ? ['…', n] : [n]));
}

export default function Pagination({
  page, pages, onPage, chargement = false, etiquette = 'Pages',
}) {
  if (pages <= 1) return null;

  return (
    <nav className="pagination" aria-label={etiquette}>
      <button
        type="button"
        className="pagination__fleche"
        onClick={() => onPage(page - 1)}
        disabled={page === 0 || chargement}
      >
        <span aria-hidden="true">‹ </span>Précédent
      </button>

      {numeros(page, pages).map((n, i) => (n === '…' ? (
        // eslint-disable-next-line react/no-array-index-key
        <span key={`etc-${i}`} className="pagination__etc" aria-hidden="true">…</span>
      ) : (
        <button
          key={n}
          type="button"
          className={`pagination__numero${n === page ? ' est-actif' : ''}`}
          aria-current={n === page ? 'page' : undefined}
          aria-label={`Page ${n + 1}`}
          onClick={() => onPage(n)}
          disabled={chargement}
        >
          {n + 1}
        </button>
      )))}

      <button
        type="button"
        className="pagination__fleche"
        onClick={() => onPage(page + 1)}
        disabled={page >= pages - 1 || chargement}
      >
        Suivant<span aria-hidden="true"> ›</span>
      </button>
    </nav>
  );
}
